import React from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import './App.css';
import { Login } from "./pages/login";
import PageModerator from "./pages/moderator";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { List, ListItem, ListItemText } from "@material-ui/core";
import Feeds from './pages/feeds';
import { Loader } from "./components/loader";
import Comments from "./pages/comments";
import { ROOT_PATH } from "./utils/constantes";
import Users from "./pages/users";
import Messages from "./components/messages";
import CommunityChallengeTemplates from "./pages/communityChallengeTemplates";

const useStyles = makeStyles((theme) => ({
  appBar: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  menu: {
    height: '100%',
    position: 'absolute',
    width: '200px',
    backgroundColor: '#3f51b5',
    color: '#ffffff',
    zIndex: 1
  }
}));

function App() {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(1);
  const [showMenu, setShowMenu] = React.useState(false);
  const navigate = useNavigate();

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
    onIconMenuClick(event);
    switch (index) {
      case 0:
        navigate(`${ROOT_PATH}/moderation`)
        break;
      case 1:
        navigate(`${ROOT_PATH}/feeds`)
        break;
      case 2:
        navigate(`${ROOT_PATH}/comments`)
        break;
      case 3:
        navigate(`${ROOT_PATH}/users`)
        break;
      case 4:
        navigate(`${ROOT_PATH}/communityChallengeTemplate`)
        break;
      default:
        break;
    }
  };

  const onIconMenuClick = (event) => {
    setShowMenu(!showMenu);
  }

  return (
    <Login>
      <div className="App">
        <div className={classes.appBar}>
          <AppBar position="static">
            <Toolbar onClick={onIconMenuClick}>
              <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                <MenuIcon />
              </IconButton>
            </Toolbar>
          </AppBar>
        </div>
        {showMenu && (
          <div className={classes.menu}>
            <List component="nav" aria-label="main mailbox folders">
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 0)}
              >
                <ListItemText primary="Moderation" />
              </ListItem>
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 1)}
              >
                <ListItemText primary="Feeds" />
              </ListItem>
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 2)}
              >
                <ListItemText primary="Comments" />
              </ListItem>
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 3)}
              >
                <ListItemText primary="Users" />
              </ListItem>
              <ListItem
                button
                selected={selectedIndex === 0}
                onClick={(event) => handleListItemClick(event, 4)}
              >
                <ListItemText primary="Challenges templates" />
              </ListItem>
            </List>
          </div>
        )}
        <Loader />
        <Messages />
        <Routes>
          <Route path={ROOT_PATH} element={<PageModerator />} />
          <Route path={`${ROOT_PATH}/moderation`} element={<PageModerator />} />
          <Route path={`${ROOT_PATH}/feeds`} element={<Feeds />} />
          <Route path={`${ROOT_PATH}/comments`} element={<Comments />} />
          <Route path={`${ROOT_PATH}/users`} element={<Users />} />
          <Route path={`${ROOT_PATH}/communityChallengeTemplate`} element={<CommunityChallengeTemplates />} />
        </Routes>
      </div>
    </Login>
  );
}

export default App;
